/**
 * @generated SignedSource<<3c72d771cddfdba46589e1f53a9bdc0d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_item$data = {
  readonly firstPhotoWebPath: string | null;
  readonly internalBuyLinks?: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"SharedRespLinksBlock_links">;
  } | null> | null;
  readonly isAuctionEnabled: boolean | null;
  readonly itemIsOnHold: boolean | null;
  readonly seller?: {
    readonly isAccessible: boolean | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarSellerInfoAndContactLazy_seller" | "PdpRespSidebarSellerInfo_seller">;
  } | null;
  readonly skus: ReadonlyArray<{
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"KlarnaOnSiteMessage_sku" | "PdpRespSidebarBlurbs_sku" | "PriceDisplay_sku">;
  } | null> | null;
  readonly storyTellingModule: {
    readonly tabs: ReadonlyArray<{
      readonly supplementaryEditorial: {
        readonly articles: ReadonlyArray<{
          readonly __typename: "WordpressArticleType";
        }> | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"KlarnaOnSiteMessage_item" | "PdpRespAuctionUrgencyInfo_item" | "PdpRespBreadcrumbs_item" | "PdpRespDetailTabs_item" | "PdpRespIconBubblesWrapper_item" | "PdpRespSellerItemsCarousel_item" | "PdpRespSharedHeroCarousel_item" | "PdpRespSharedPrintDetailsLazy_item" | "PdpRespSidebarBlurbs_item" | "PdpRespSidebarButtons_item" | "PdpRespSidebarPillsLazy_item" | "PdpRespSidebarSellerInfoAndContactLazy_item" | "PdpRespSidebarSellerInfo_item" | "PdpRespSimilarItemsCarousel_item" | "PdpRespSimilarItemsLanding_item" | "PdpRespSwatchSelector_item" | "PdpRespTitle_item" | "PdpRespYMALItemsCarousel_item" | "PdpSharedAuctionCountdownLazy_item" | "PdpSharedAuctionInfo_item" | "PdpSharedEditorialArticles_item" | "PdpSharedFramingStatus_item" | "PdpSharedQuantitySelect_item" | "PdpSharedRecentHistoryTrackerDeprecated_item" | "PdpSharedSidebarFavorites_item" | "PriceDisplay_item" | "SharedRespLinksBlock_item" | "usePdpNetPriceVariant_item">;
  readonly " $fragmentType": "PdpRespContainer_item";
};
export type PdpRespContainer_item$key = {
  readonly " $data"?: PdpRespContainer_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespContainer_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v1 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v2 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v3 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v4 = [
  (v0/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
],
v5 = [
  {
    "kind": "Literal",
    "name": "hasSkuId",
    "value": true
  },
  (v0/*: any*/),
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchAuction"
    },
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    },
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_item",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "small"
        }
      ],
      "kind": "ScalarField",
      "name": "firstPhotoWebPath",
      "storageKey": "firstPhotoWebPath(size:\"small\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "alias": "itemIsOnHold",
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        }
      ],
      "kind": "ScalarField",
      "name": "isOnHold",
      "storageKey": null
    },
    {
      "condition": "fetchAuction",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespAuctionUrgencyInfo_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedAuctionInfo_item"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedEditorialArticles_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsLanding_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespBreadcrumbs_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespTitle_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarPillsLazy_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespYMALItemsCarousel_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsCarousel_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSellerItemsCarousel_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedQuantitySelect_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedRecentHistoryTrackerDeprecated_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_item"
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": (v4/*: any*/),
          "kind": "FragmentSpread",
          "name": "PriceDisplay_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedFramingStatus_item"
        }
      ]
    },
    {
      "condition": "isMultiSku",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSwatchSelector_item"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDetailTabs_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedPrintDetailsLazy_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSidebarFavorites_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionCountdownLazy_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePdpNetPriceVariant_item"
    },
    {
      "args": (v4/*: any*/),
      "kind": "FragmentSpread",
      "name": "KlarnaOnSiteMessage_item"
    },
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "seller",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAccessible",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSidebarSellerInfoAndContactLazy_seller"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSidebarSellerInfo_seller"
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSharedHeroCarousel_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespIconBubblesWrapper_item"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InternalBuyLinkType",
          "kind": "LinkedField",
          "name": "internalBuyLinks",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SharedRespLinksBlock_links"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfoAndContactLazy_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfo_item"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "skus",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "condition": "isMultiSku",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": (v5/*: any*/),
              "kind": "FragmentSpread",
              "name": "PriceDisplay_sku"
            },
            {
              "args": (v5/*: any*/),
              "kind": "FragmentSpread",
              "name": "KlarnaOnSiteMessage_sku"
            }
          ]
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSidebarBlurbs_sku"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoryTellingModule",
      "kind": "LinkedField",
      "name": "storyTellingModule",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoryTellingTab",
          "kind": "LinkedField",
          "name": "tabs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WordpressArticlesType",
              "kind": "LinkedField",
              "name": "supplementaryEditorial",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "WordpressArticleType",
                  "kind": "LinkedField",
                  "name": "articles",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "4517399f170679b641fbb9e051c8d703";

export default node;
